import {web3} from '../web3.js';
import EthereumTransaction from 'decentralized/transactions/EthereumTransaction.js';
import BackendQuery from 'decentralized/BackendQuery.js';
import EffectsContract from 'decentralized/contracts/EffectsContract.js';
import {NewEffect} from 'decentralized/EthereumEvents.js';
import {EFFECTS} from 'decentralized/transactions/contracts.js';
import ipfs from '../Ipfs.js';
import {ipfsHashToBytes32} from 'utils/ipfsHash.js';

export const newEffectPreset = async (json, title, guildId=0) => {
    let effectType = json.name;
    let hash = ipfsHashToBytes32(await ipfs.addJson(json));

    new EthereumTransaction(
        EFFECTS, 'newEffect', [hash, web3.utils.fromAscii(effectType), title, guildId]).
        execute();
};

export const getEffectPresets = async (effectType) => {

    let query = new BackendQuery(
        new EffectsContract().contractAddress)
        .from(NewEffect)
        .select("title")
        .select("ipfsHash")
        .select("effectType")
        .select("user");

    if (effectType) {
        query.where("effectType", effectType);
    }

    let r = await query.executeQuery();
    return r;
}
